import { useEffect, useState } from "react";
import patientController from "../../../../apis/Controllers/PatientController/patient.controller";
import { useLocation, useNavigate } from "react-router";
import taskController from "../../../../apis/Controllers/TaskController/task.controller";
import { Toaster } from "../../../Helper/toaster/Toaster";
import reportsController from "../../../../apis/Controllers/ReportsController/reports.controller";
import vitalsController from "../../../../apis/Controllers/VitalsController/vitals.controller";
import Validation from "../../../Helper/validations/vaildation";
import store from "../../../../redux/store";
import permissionsController from "../../../../apis/Controllers/PermissionsController/permissions.contoller";
import { getExtension } from "../../../Helper/General";
import { Image } from "react-bootstrap";
import { DocExt, ImageExt, PdfImg } from "../../../../assets/images";
import medicineController from "../../../../apis/Controllers/MedicineController/medicine.controller";
import moment from "moment";

const PatientDetailFunctions = () => {
    var [breadcrumData, setBreadcrumData] = useState(["Dashboard", "Patient List"]);
    var breadcrumItem = "Patient Details";
    const defaultValues = {
        temperature: "",
        weight: "",
        heartbeat: "",
        bloodPressureTop: "",
        bloodPressureBottom: "",
        oxygenSaturationTop: "",
        oxygenSaturationBottom: "",
        bloodSuger: "",
    };
    const defaultErrors = {
        heartbeat: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        weight: {
            rules: [],
            isValid: true,
            message: "",
        },
        temperature: {
            rules: [],
            isValid: true,
            message: "",
        },
        bloodPressureTop: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        bloodPressureBottom: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        oxygenSaturationTop: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        oxygenSaturationBottom: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        bloodSuger: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
    };

    const [isError, setError] = useState(defaultErrors);
    const [values, setValues] = useState(defaultValues);
    const [showLogin, setShowLogin] = useState(false);
    const [showUpdateVitalModal, setShowUpdateVitalModal] = useState(false);
    const [currentTab, setCurrentTab] = useState("1");
    const [patientData, setPatientData] = useState(null);
    const [medicalRecordTags, setMedicalRecordTags] = useState(null);
    const [patientReportsList, setPatientReportsList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [vitalsList, setVitalsList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loader2, setLoader2] = useState(false);
    const [profileModal, setProfileModal] = useState(false);
    //<----------------------Permissions--------------------------------------->
    const [checkPermissions, setCheckPatientModulePermissions] = useState(null);
    const [checkTaskPermissions, setCheckTaskModulePermissions] = useState(null);
    const [checkVitalPermissions, setVitalCheckPermissions] = useState(null);
    const [checkReportPermissions, setReportCheckPermissions] = useState(null);
    const [checkMedicinePermissions, setMedicineCheckPermissions] = useState(null);
    const [checkLabPermissions, setLabCheckPermissions] = useState(null);
    const [checkLogsPermissions, setLogsCheckPermissions] = useState(null);
    const [checkPatinetCasePermissions, setPatinetCaseCheckPermissions] = useState(null);
    //<------------------------------------------------------------------------
    const [patientId, setPatientId] = useState(null);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [filterSortByValue, setFilterSortByValue] = useState(null);
    const [patientActiveCaseDetail, setPatientActveCaseDetail] = useState(null);
    // -------------------PAZINATION ---------------------------------------->
    const [itemsPerPage, setItemsPerPage] = useState(5);
    //<--------------------Task Pazination---------------------------
    const [page, setPage] = useState(1);
    const [taskListCount, setTaskListCount] = useState(0);
    const [taskListTotalPages, setTaskListTotalPages] = useState([]);

    //----------------------Reports Pazination------------------------
    const [reportsPage, setReportPage] = useState(1);
    const [reportListCount, setReportListCount] = useState(0);
    const [reportListTotalPages, setReportListTotalPages] = useState([]);

    //<----------------------Health Pazination-----------------------------
    const [vitalsPage, setVitalsPage] = useState(1);
    const [vitalsListCount, setVitalsListCount] = useState(0);
    const [vitalsListTotalPages, setVitalsListTotalPages] = useState([]);

    //<---------------------Medicine Tab------------------------
    const [medicinePage, setMedicinePage] = useState(1)
    const [medicineCount, setMedicineCount] = useState(0)
    const [medicineTotalPages, setMedicineTotalPages] = useState([]);
    const [medicineList, setMedicineList] = useState([])
    const [deletMedicineDetail, setDeletMedicineDetail] = useState(null);
    const [deletConfirmationModal, setDeletConfirmationModal] = useState(false);
    const [completMedicalConfirmationModal, setCompletMedicineConfimationModal] = useState(false);
    const [completeMedicineDetail, setCompleteMedicineDetail] = useState(null);
    const [medicineDataForCommentApi, setMedicineDataForCommentApi] = useState(null);
    const [medicineComment, setMedicineComment] = useState(false);
    const [dateParam, setDateParam] = useState(moment().format('YYYY-MM-DD'))
    //<--------------------------------------------------------------
    const [tabs, setTabs] = useState([]);
    const [patientStatus, setPatientStatus] = useState([
        { id: 'admitted', value: 'Admitted' },
        { id: 'under_treatment', value: 'Under Treatment' },
        { id: 'critical', value: 'Critical' },
        { id: 'discharge', value: 'Discharged' },
    ]);

    let userdata = localStorage.getItem('SET_USER_DATA');
    let User = JSON.parse(userdata);

    let navigate = useNavigate();
    const loaction = useLocation();

    const tab = [
        // {
        //     id: 1,
        //     tabTitle: "Task",
        // },
        // {
        //     id: 2,
        //     tabTitle: "Reports",
        // },
        // {
        //     id: 3,
        //     tabTitle: "Lab",
        // },
        // {
        //     id: 4,
        //     tabTitle: "Health",
        // },
        // {
        //     id: 5,
        //     tabTitle: "Logs",
        // },
        // {
        //     id: 6,
        //     tabTitle: "Medicine",
        // },
    ];



    useEffect(() => {
        if (checkTaskPermissions) {
            let tabBar = [...tabs]
            if (checkTaskPermissions
                && checkTaskPermissions.permissions
                && checkTaskPermissions.permissions.length > 0
                && parseInt(checkTaskPermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Task')
                if (checkId === -1) {
                    tabBar.push({
                        id: 1,
                        tabTitle: "Task",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkTaskPermissions]);


    useEffect(() => {
        if (checkReportPermissions) {
            let tabBar = [...tabs]
            if (checkReportPermissions
                && checkReportPermissions.permissions
                && checkReportPermissions.permissions.length > 0
                && parseInt(checkReportPermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Reports')
                if (checkId === -1) {
                    tabBar.push({
                        id: 2,
                        tabTitle: "Reports",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkReportPermissions]);


    // useEffect(() => {
    //     if (checkLabPermissions) {
    //         let tabBar = [...tabs]
    //         if (checkLabPermissions
    //             && checkLabPermissions.permissions
    //             && checkLabPermissions.permissions.length > 0
    //             && parseInt(checkLabPermissions.permissions[0].value) === 1) {
    //             let checkId = tabBar.findIndex((item) => item.tabTitle === 'Lab')
    //             if (checkId === -1) {
    //                 tabBar.push({
    //                     id: 3,
    //                     tabTitle: "Lab",
    //                 })
    //             }
    //             else;
    //         }
    //         else {
    //             return tabBar
    //         }
    //         setTabs(tabBar);
    //     }
    // }, [checkLabPermissions]);


    useEffect(() => {
        if (checkVitalPermissions) {
            let tabBar = [...tabs]
            if (checkVitalPermissions
                && checkVitalPermissions.permissions
                && checkVitalPermissions.permissions.length > 0
                && parseInt(checkVitalPermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Health')
                if (checkId === -1) {
                    tabBar.push({
                        id: 4,
                        tabTitle: "Health",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkVitalPermissions]);


    // useEffect(() => {
    //     if (checkLogsPermissions) {
    //         let tabBar = [...tabs]
    //         if (checkLogsPermissions
    //             && checkLogsPermissions.permissions
    //             && checkLogsPermissions.permissions.length > 0
    //             && parseInt(checkLogsPermissions.permissions[0].value) === 1) {
    //             let checkId = tabBar.findIndex((item) => item.tabTitle === 'Logs')
    //             if (checkId === -1) {
    //                 tabBar.push({
    //                     id: 5,
    //                     tabTitle: "Logs",
    //                 })
    //             }
    //             else;
    //         }
    //         else {
    //             return tabBar
    //         }
    //         setTabs(tabBar);
    //     }
    // }, [checkLogsPermissions]);


    useEffect(() => {
        if (checkMedicinePermissions) {
            let tabBar = [...tabs]
            if (checkMedicinePermissions
                && checkMedicinePermissions.permissions
                && checkMedicinePermissions.permissions.length > 0
                && parseInt(checkMedicinePermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Medicine')
                if (checkId === -1) {
                    tabBar.push({
                        id: 6,
                        tabTitle: "Medicine",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkMedicinePermissions]);


    const handleTabData = (tabId) => {                    //<-------------onChange Tab
        if (parseInt(tabId) === 1) {
            getTaskListing(1, patientId);
        } else if (parseInt(tabId) === 2) {
            getReportsListng(1);
        } else if (parseInt(tabId) === 4) {
            getHealthListing(1);
        } else if (parseInt(tabId) === 6) {
            getMedicineListing(1)
        }
        else return;
    };

    //----------------------------------------Permissions Module-------------------------------------------------->

    const getPatientModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('user');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setCheckPatientModulePermissions(data);
        }
        else {
            setCheckPatientModulePermissions(null);
        }
    };


    const getTaskModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('task');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setCheckTaskModulePermissions(data);
        }
        else {
            setCheckTaskModulePermissions(null);
        }
    };


    const getReportsModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('report');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setReportCheckPermissions(data);
        }
        else {
            setReportCheckPermissions(null);
        }
    };


    const getLabModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('lab');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setLabCheckPermissions(data);
        }
        else {
            setLabCheckPermissions(null);
        }
    };


    const getVitalModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('vital');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setVitalCheckPermissions(data);
        }
        else {
            setVitalCheckPermissions(null);
        }
    };



    const getLogsModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('log');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setLogsCheckPermissions(data);
        }
        else {
            setLogsCheckPermissions(null);
        }
    };


    const getMedicineModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('medicine');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setMedicineCheckPermissions(data);
        }
        else {
            setMedicineCheckPermissions(null);
        }
    };
    

    const getPatientCaseModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('case');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setPatinetCaseCheckPermissions(data);
        }
        else {
            setPatinetCaseCheckPermissions(null);
        }
    };

    //<-----------------------------------------------------------------------------------------------------Permissions Module

    const getPatientDetail = async (patinetId) => {
        setLoader(true);
        let response = await patientController.patientDetail(patinetId);
        if (response && response.status) {
            let data = response.data.vitals[0];
            let cases = response.data.cases
            setPatientData(response.data);
            setLoader(false);
            setValues({
                ...values,
                temperature: data && data.temperature ? data.temperature : null,
                weight: data && data.weight ? data.weight : null,
                heartbeat: data && data.heart_beat ? data.heart_beat : null,
                bloodPressureTop:
                    data && data.blood_pressure_top
                        ? data.blood_pressure_top
                        : null,
                bloodPressureBottom:
                    data && data.blood_pressure_bottom
                        ? data.blood_pressure_bottom
                        : null,
                oxygenSaturationTop:
                    data && data.oxygen_saturation_top
                        ? data.oxygen_saturation_top
                        : null,
                oxygenSaturationBottom:
                    data && data.oxygen_saturation_bottom
                        ? data.oxygen_saturation_bottom
                        : null,
                bloodSuger: data && data.blood_suger ? data.blood_suger : null,
            });
            //<--------------------------------permissions
            // getPatientModulePermissions();
            // getTaskModulePermissions();
            // getReportsModulePermissions();
            // getLabModulePermissions();
            // getVitalModulePermissions();
            // getLogsModulePermissions();
            // getMedicineModulePermissions();
            // getPatientCaseModulePermissions();
            //<----------------------------------
            getPatientActiveCaseDetail(cases);
            getTaskListing(1, response.data.id);
            setPatientId(response.data.id);
            if (loaction && loaction.state && loaction.state.name == "fromAssignMedicine") {
                setCurrentTab('6');
                getMedicineListing(1, response.data.id);
            }
        } else {
            setPatientData(null);
            setLoader(false);
        }
    };


    const getPatientActiveCaseDetail = (cases) => {
        if (cases && cases.length > 0) {
            for (let i in cases) {
                if (parseInt(cases[i].case_status) === 1) {
                    setPatientActveCaseDetail(cases[i]);
                } else {
                    setPatientActveCaseDetail(null);
                }
            }
        } else return;
    };


    const manageMedicalRecordsTags = (tags) => {
        if (tags) {
            const data = tags.replace(/,/g, "")
            let tag = data.split(" ");
            return (
                tag.map((item, i) => (
                    <li
                        className="category color"
                        key={i}
                    >
                        <p> {item}</p>
                    </li>
                ))
            )
        }
    };


    const chnagePatientStatus = async (id, status) => {
        if (!loader) {
            let post = {
                patient_status: status ? status : '',
            }
            setLoader(true)
            let response = await patientController.updatePatientStatus(id, post);
            if (response && response.status) {
                setLoader(false)
                new Toaster().success(response.message);
                getPatientDetail(patientId);
            }
            else {
                setLoader(false)
            }
        }
    };


    const handleBreadcrumDataNaviagtion = (i) => {
        let user = store.getState().UserReducer.user;
        if (i === 0) {
            if (user && parseInt(user.user_type) === 2) {
                navigate('/dashboard');
            }
            else {
                navigate('/dashboard-superadmin');
            }
        }
        else if (i === 1) {
            if (loaction && loaction.state && loaction.state.name1 == "tasklist") {
                navigate('/task-list');
            } else {
                navigate('/manage-patient-list');
            }

        }
        else return;
    };


    //<------------------------------------------------Task Module ------------------------------------------------------

    const getTaskListing = async (page, id, sortBy) => {
        let post = {
            patient_id: id ? id : patientData && patientData.id ? patientData.id : null,
            page: page ? page : 1,
            limit: 6,
            sort: sortBy ? sortBy : ''
        };
        setLoader2(true);
        let response = await taskController.taskListingPatientDetails(post);
        if (response && response.status) {
            setTaskListCount(response.count);
            setTaskList(response.data);
            setLoader2(false);
        } else {
            setLoader2(false);
            setTaskList([]);
        }
    };


    const taskCompletedByAdmin = async (item) => {
        let patientId = loaction && loaction.state && loaction.state.id ? loaction.state.id
            : "";
        setLoader(true);
        let id = item && item.id ? item.id : "";
        let response = await taskController.taskComplete(id);
        if (response && response.status) {
            getTaskListing(page, patientId);
            new Toaster().success(response.message);
            getPatientDetail(patientId);
            setLoader(false);
        } else {
            setLoader(false);
        }
    };


    const applyFilters = async (filter) => {
        if (filter) {
            setFilterSortByValue(filter && filter.sortByAlpha);
            getTaskListing(1, patientId, filter && filter.sortByAlpha && filter.sortByAlpha.value ? filter.sortByAlpha.value : '');
        }
    };


    const handleClearAllFilters = () => {
        setFilterSortByValue(null);
        getTaskListing(1, patientId, '');
    };


    //<---------------------------------------Pazination Task Listing----------------------------------------------

    useEffect(() => {
        if (taskListCount) {
            handleTaskListPages(taskListCount);
        }
    }, [taskListCount]);


    const handlePage = (e) => {
        setPage(e);
        getTaskListing(e, patientId);
    };


    const handleTaskListPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setTaskListTotalPages(array);
    };


    const handleTaskBackClick = () => {
        if (page > 1) {
            let newpage = page - 1;
            setPage(page - 1);
            getTaskListing(newpage, patientId);
        } else return;
    };


    const handleTaskNextClick = () => {
        if (page >= 1 && page < taskListTotalPages.length) {
            let newpage = page + 1;
            setPage(page + 1);
            getTaskListing(newpage, patientId);
        } else return;
    };


    //---------------------------------Report module--------------------------------------------------------------->

    const getReportsListng = async (page) => {
        let post = {
            patient_id: patientData && patientData.id ? [patientData.id] : [],
            page: page ? page : 1,
            limit: 5
        };
        setLoader2(true);
        let response = await reportsController.reportsListing(post);
        if (response && response.status) {
            setReportListCount(response.count);
            setPatientReportsList(response.data);
            setLoader2(false);
        } else {
            setPatientReportsList(null);
            setLoader2(false);
        }
    };

    const handleDeleteReport = async (reportId) => {
        let id = reportId ? reportId : "";
        setLoader2(true);
        let response = await reportsController.reportDelete(id);
        if (response && response.status) {
            new Toaster().success(response.message);
            getReportsListng(reportsPage);
            setLoader2(false);
        } else {
            setLoader2(false);
        }
    };

    const handleAddReport = async (values) => {
        let response = await reportsController.reportsCreate(
            values,
            patientData
        );
        if (response && response.status) {
            new Toaster().success(response.message);
            getReportsListng(1);
            setLoader2(false);
            return response;
        } else {
            setLoader2(false);
            return null;
        }
    };


    const handleRenderImage = (item) => {                              //<----------------Report Image render
        let doc = item.attachment ? item.attachment : ''
        if (doc) {
            let ext = getExtension(item.attachment);
            if (ext) {
                if (ext === 'doc') {
                    return (
                        <Image
                            src={DocExt}
                            alt="..."
                        />
                    )
                }
                else if (ext === 'pdf') {
                    return (
                        <Image
                            src={PdfImg}
                            alt="..."
                        />
                    )
                }
                else {
                    return (
                        <Image
                            src={ImageExt}
                            alt="..."
                        />
                    )
                }
            }
        }
        else {
            return (
                <Image
                    src={ImageExt}
                    alt="..."
                />
            )
        }
    };


    //<---------------------------------------------Pazination Report Module-------------------------------------

    useEffect(() => {
        if (reportListCount) {
            handleReportsPages(reportListCount);
        }
    }, [reportListCount]);


    const handleReportsPage = (e) => {
        setReportPage(e);
        getReportsListng(e);
    };


    const handleReportsPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setReportListTotalPages(array);
    };


    const handleReportsBackClick = () => {
        if (reportsPage > 1) {
            let newpage = reportsPage - 1;
            setReportPage(reportsPage - 1);
            getReportsListng(newpage);
        } else return;
    };


    const handleReportsNextClick = () => {
        if (reportsPage >= 1 && reportsPage < reportListTotalPages.length) {
            let newpage = reportsPage + 1;
            setReportPage(reportsPage + 1);
            getReportsListng(newpage);
        } else return;
    };



    //----------------------------------------------------Health module------------------------------------------------------------->

    const getHealthListing = async (page) => {
        let post = {
            patient_id: patientData && patientData.id ? [patientData.id] : [],
            page: page ? page : 1,
            limit: 5
        };
        setLoader2(true);
        let response = await vitalsController.vitalsListing(post);
        if (response && response.status) {
            setLoader2(false);
            setVitalsListCount(response.count);
            setVitalsList(response.data);
        } else {
            setLoader2(false);
            setVitalsList([]);
        }
    };


    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };


    const updateHealth = async () => {
        let id = loaction && loaction.state && loaction.state.id ? loaction.state.id : "";
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            let response = await vitalsController.updateVitals(
                patientData,
                values
            );
            if (response && response.status) {
                new Toaster().success(response.message);
                setShowUpdateVitalModal(false);
                getHealthListing(vitalsPage);
                getPatientDetail(id);
            }
            else {
                setShowUpdateVitalModal(false);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    //<--------------------------------------------------HEALTH Pazination ----------------------------------------------------------->

    useEffect(() => {
        if (vitalsListCount) {
            handleHealthListPages(vitalsListCount);
        }
    }, [vitalsListCount]);


    const handleHealthPage = (e) => {
        setVitalsPage(e);
        getHealthListing(e);
    };


    const handleHealthListPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setVitalsListTotalPages(array);
    };


    const handleHealthBackClick = () => {
        if (vitalsPage > 1) {
            let newpage = vitalsPage - 1;
            setVitalsPage(newpage);
            getHealthListing(newpage);
        } else return;
    };


    const handleHealthNextClick = () => {
        if (vitalsPage >= 1 && vitalsPage < vitalsListTotalPages.length) {
            let newpage = vitalsPage + 1;
            setVitalsPage(newpage);
            getHealthListing(newpage);
        } else return;
    };


    const handleMRButton = () => {
        if (patientData &&
            patientData.cases &&
            patientData.cases.length > 0) {
            if (parseInt(patientData.cases[0].case_status) === 1) {
                navigate('/add-case', { state: { caseId: patientData.cases[0].id, name: 'editCase' } })
            }
            else {
                navigate('/add-case', { state: { caseId: patientData.cases[0].id, name: 'addCase' } })
            }
        }
    };



    //------------------------------------------Medicine module------------------------------------------------------->

    useEffect(() => {
        if(dateParam){
            getMedicineListing(1)
        }
    }, [dateParam]);

    const getMedicineListing = async (page, patienetId) => {
        let post = {
            patient_id: patienetId ? [patienetId] : patientData && patientData.id ? [patientData.id] : [],
            page: page ? page : 1,
            limit: 5,
            date: dateParam ? dateParam : ''
        };
        setLoader2(true);
        let response = await medicineController.medicineListing(post);
        if (response && response.status) {
            setMedicineList(response.data);
            setMedicineCount(response.count)
            setLoader2(false);
        } else {
            setMedicineList([]);
            setMedicineCount(null)
            setLoader2(false);
        }
    };


    const handleDeleteMedicine = async () => {
        let data = deletMedicineDetail ? deletMedicineDetail : null
        if (data) {
            let array = [...medicineList]
            let id = data && data.medicine_id ? data.medicine_id : '';
            let ids = data && data.frequency_id ? data.frequency_id : ''

            let response = await medicineController.medicineDelete(id, ids);
            if (response && response.status) {
                new Toaster().success(response.message);
                let filterData = array.filter((data) => data.id !== data.id);
                if (filterData.length > 0) {
                    getMedicineListing(medicinePage);
                }
                else {
                    if (medicinePage > 1) {
                        let newpage = medicinePage - 1
                        setMedicinePage(medicinePage - 1);
                        getMedicineListing(newpage);
                    }
                    else {
                        setMedicinePage(medicinePage);
                        getMedicineListing(medicinePage);
                    }
                }
                setDeletConfirmationModal(false);
            } else {
                setDeletConfirmationModal(false);
            }
        }
        else {
            setDeletConfirmationModal(false);
        }
    };


    const handleCompleteMedicine = async () => {
        let data = completeMedicineDetail ? completeMedicineDetail : null
        if (data) {
            let id = data && data.medicine_id ? data.medicine_id : '';
            let post = {
                medicine_status: 1,
                frequency_id: data && data.frequency_id ? data.frequency_id : ''
            }
            let response = await medicineController.completeMedicine(id, post);
            if (response && response.status) {
                new Toaster().success(response.message);
                getMedicineListing(medicinePage);
                setCompletMedicineConfimationModal(false);
            }
            else {
                setCompletMedicineConfimationModal(false);
            }
        }
        else {
            setCompletMedicineConfimationModal(false);
        }
    };


    const handleAddCommentInMedicineTab = async (value) => {
        let data = medicineDataForCommentApi ? medicineDataForCommentApi : null
        if (data) {
            let id = data && data.medicine_id ? data.medicine_id : '';
            let post = {
                comment: value && value.comment ? value.comment : '',
                frequency_id: data && data.frequency_id ? data.frequency_id : ''
            }
            let response = await medicineController.addComment(id, post);
            if (response && response.status) {
                new Toaster().success(response.message);
                getMedicineListing(medicinePage);
                setMedicineComment(false);
            }
            else {
                setMedicineComment(false);
            }
        }
        else {
            setMedicineComment(false);
        }
    };

    //-------------------------------------Medicine Pazination------------------------------------------------>

    useEffect(() => {
        if (medicineCount) {
            handleMedicinePages(medicineCount);
        }
    }, [medicineCount]);


    const handleMedicinePage = (e) => {
        setMedicinePage(e);
        getMedicineListing(e);
    };


    const handleMedicinePages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setMedicineTotalPages(array);
    };


    const handleMedicineBackClick = () => {
        if (medicinePage > 1) {
            let newpage = medicinePage - 1;
            setMedicinePage(medicinePage - 1);
            getMedicineListing(newpage);
        } else return;
    };


    const handleMedicineNextClick = () => {
        if (medicinePage >= 1 && medicinePage < medicineTotalPages.length) {
            let newpage = medicinePage + 1;
            setMedicinePage(medicinePage + 1);
            getMedicineListing(newpage);
        } else return;
    };


    return {
        //<----------------------------Permissions 
        checkPermissions,
        checkTaskPermissions,
        checkVitalPermissions,
        checkReportPermissions,
        checkMedicinePermissions,
        checkLabPermissions,
        checkLogsPermissions,
        checkPatinetCasePermissions,
        getPatientModulePermissions,
        getTaskModulePermissions,
        getVitalModulePermissions,
        getReportsModulePermissions,
        getMedicineModulePermissions,
        getLabModulePermissions,
        getLogsModulePermissions,
        getPatientCaseModulePermissions,
        //<------------------------------
        setTabs,
        breadcrumData,
        breadcrumItem,
        navigate,
        loaction,
        showUpdateVitalModal,
        setShowUpdateVitalModal,
        showLogin,
        setShowLogin,
        currentTab,
        setCurrentTab,
        tabs,
        getPatientDetail,
        patientData,
        breadcrumItem,
        loader,
        loader2,
        medicalRecordTags,
        taskCompletedByAdmin,
        patientReportsList,
        handleTabData,
        handleDeleteReport,
        handleAddReport,
        getTaskListing,
        taskList,
        vitalsList,
        values,
        isError,
        handleChange,
        getHealthListing,
        updateHealth,
        page,
        handlePage,
        setItemsPerPage,
        taskListCount,
        handleTaskBackClick,
        handleTaskNextClick,
        handleReportsPage,
        handleReportsBackClick,
        handleReportsNextClick,
        handleHealthPage,
        handleHealthBackClick,
        handleHealthNextClick,
        reportsPage,
        vitalsPage,
        taskListTotalPages,
        reportListTotalPages,
        vitalsListTotalPages,
        profileModal,
        setProfileModal,
        handleBreadcrumDataNaviagtion,
        handleMRButton,
        manageMedicalRecordsTags,
        handleRenderImage,
        showFilterModal,
        setShowFilterModal,
        applyFilters,
        filterSortByValue,
        handleClearAllFilters,
        patientActiveCaseDetail,
        // setBreadcrumItem,
        patientStatus,
        setPatientStatus,
        chnagePatientStatus,
        setBreadcrumData,
        breadcrumData,
        //<--------------------medicine tab
        getMedicineListing,
        medicineList,
        handleMedicinePage,
        handleMedicineBackClick,
        handleMedicineNextClick,
        medicinePage,
        medicineTotalPages,
        handleDeleteMedicine,
        deletMedicineDetail,
        setDeletMedicineDetail,
        deletConfirmationModal,
        setDeletConfirmationModal,
        completMedicalConfirmationModal,
        setCompletMedicineConfimationModal,
        completeMedicineDetail,
        setCompleteMedicineDetail,
        handleCompleteMedicine,
        medicineComment,
        setMedicineComment,
        medicineDataForCommentApi,
        setMedicineDataForCommentApi,
        handleAddCommentInMedicineTab,
        dateParam,
        setDateParam,
        User
    };
};

export default PatientDetailFunctions;
